/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Rephrase_ExpandInputs */



/**
* | output |
* | --- |
* | "Rephrase - Expand" |
*
* @param {Event_Ad_Rephrase_ExpandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_rephrase_expand = /** @type {((inputs?: Event_Ad_Rephrase_ExpandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Rephrase_ExpandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reformuler - Etendre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umformulieren – Erweitern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riformulare - Espandere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перефразировать - Развернуть")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reformular - Expandir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("改写 - 扩展")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言い換え - 展開")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुनर्कथन - विस्तार करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reformule - Expanda")
	return /** @type {LocalizedString} */ ("Rephrase - Expand")
});